// @flow

import { getPdbItem } from './main';
import { getDeliveryTime, getPackageIdFromUrl } from './packages';
import type { State } from '../types';
import type { State as RouterState } from '../../router/types';

type GlobalState = {
  pdb: State,
  router: RouterState,
};

export const getShortestDeliveryTime = (
  state: GlobalState,
  pdbId: ?string = null,
  packageId?: ?string = null,
): number => {
  // If a package is selected,
  const pkgId = packageId || getPackageIdFromUrl(state);
  if (pkgId) {
    // we'll need to retrieve the delivery time of the package.
    const deliveryTime = getDeliveryTime(state, pdbId, pkgId);
    // If the package delivery time can be retrieved successfully,
    if (deliveryTime) {
      // we can return the delivery time of the selected package.
      return deliveryTime;
    }
  }

  // In all other cases, we'll return the delivery time of the pdb item.
  const pdbItem = getPdbItem(state, pdbId);
  return pdbItem.shortestDeliveryTime;
};

export default null;
